// Support page — guides, tips and FAQ (previously only Turkish fallbacks in code).
const en = {
  "support.guideUploadTitle": "How to Upload Music",
  "support.guideUpload1": "Step 1: Create a New Release",
  "support.guideUpload1Content": "Go to \"Releases\" and click \"New Release\". Choose Single (1 track) or Album/EP (multiple tracks).",
  "support.guideUpload2": "Step 2: Upload Your Audio",
  "support.guideUpload2Content": "Upload your audio as WAV (recommended) or high-quality MP3 (minimum 320 kbps).",
  "support.guideUpload3": "Step 3: Add Release Details",
  "support.guideUpload3Content": "Fill in the release title, primary artist, genre and release date. Add featured artists if there are any.",
  "support.guideUpload4": "Step 4: Upload the Cover Art",
  "support.guideUpload4Content": "Upload a square JPG or PNG image (minimum 3000×3000 pixels).",
  "support.guideUpload5": "Step 5: Add Track Details",
  "support.guideUpload5Content": "For each track, enter the title, ISRC code (optional), songwriters and producers.",
  "support.guideUpload6": "Step 6: Review and Submit",
  "support.guideUpload6Content": "Review all details carefully. After submission your release is reviewed within 24–72 hours.",
  "support.tip1": "Use WAV for the best audio quality",
  "support.tip2": "Cover art must be square (1:1 ratio)",
  "support.tip3": "Schedule releases at least 7 days in advance",
  "support.tip4": "Make sure artist names are spelled correctly",
  "support.guidePaymentsTitle": "How Payments Work",
  "support.guidePayments1": "Royalty Earnings",
  "support.guidePayments1Content": "You earn royalties every time your music is streamed or downloaded on Spotify, Apple Music, YouTube Music and many more platforms.",
  "support.guidePayments2": "Commission Structure",
  "support.guidePayments2Content": "Free plan: 20% commission. Artist Unlimited: 0% commission.",
  "support.guidePayments3": "Withdrawal Requirements",
  "support.guidePayments3Content": "Complete your payout profile, add a verified payout method and reach a minimum balance of $50.",
  "support.guidePayments4": "Weekly Withdrawal Limit",
  "support.guidePayments4Content": "Up to 2 withdrawal requests per week. Each is processed within 3–5 business days.",
  "support.tip5": "Complete your payout profile and tax details before requesting a withdrawal",
  "support.tip6": "Bank transfers have lower fees than PayPal",
  "support.tip7": "Earnings appear 30–60 days after the streams",
  "support.guideDistributionTitle": "Distribution Guide",
  "support.guideDistribution1": "Supported Platforms",
  "support.guideDistribution1Content": "Your music is distributed to 150+ platforms including Spotify, Apple Music, YouTube Music, Amazon Music, Deezer, Tidal and TikTok.",
  "support.guideDistribution2": "Delivery Times",
  "support.guideDistribution2Content": "Standard delivery: 2–5 business days. Priority delivery (paid plans): 24–72 hours.",
  "support.guideDistribution3": "Content Requirements",
  "support.guideDistribution3Content": "Original content only. Cover songs require proper licensing. Remixes require the original artist's permission.",
  "support.guideDistribution4": "Audio Quality",
  "support.guideDistribution4Content": "WAV files: 16-bit or 24-bit, 44.1 kHz or higher. MP3 files: minimum 320 kbps.",
  "support.tip8": "Plan releases 2–4 weeks ahead for pre-save campaigns",
  "support.tip9": "Friday is the standard music release day",
  "support.tip10": "Promote before and after the release",
  "support.faq1Q": "How long does it take for my release to go live?",
  "support.faq1A": "Once approved, your release usually appears on all platforms within 2–5 business days.",
  "support.faq2Q": "Can I edit my release after it is live?",
  "support.faq2A": "You can request changes by opening a support ticket. Metadata changes can usually be updated.",
  "support.faq3Q": "Why is my withdrawable balance different from my total balance?",
  "support.faq3A": "New earnings have a 30-day holding period before they become withdrawable.",
  "support.faq4Q": "Do I need to verify my identity (KYC) to get paid?",
  "support.faq4A": "No. You only need a completed payout profile (with tax details) and a verified payout method.",
  "support.faq5Q": "Can I release cover songs?",
  "support.faq5A": "Yes, but you need a mechanical license. Upload proof of the license when submitting.",
  "support.faq6Q": "How do revenue splits work?",
  "support.faq6A": "You can share earnings with collaborators. Invite contributors by e-mail, set the percentages and earnings are distributed automatically.",
  "support.faq7Q": "What happens if my release is rejected?",
  "support.faq7A": "You'll get a notification explaining why. Fix the issues and resubmit.",
  "support.filterStatus": "Status filter",
  "support.allStatuses": "All statuses",
  "support.noResults": "No results found",
  "support.noResultsDesc": "We couldn't find any support tickets matching your search.",
  "support.emptyDesc": "Whenever you need help, you can create a new ticket here.",
  "support.createFirst": "Create your first ticket",
  "support.guideSteps": "{n} steps",
  "support.readGuide": "Read the guide",
  "support.guideFollow": "Follow the step-by-step guide",
  "support.proTips": "Pro tips",
  "support.faqTitle": "Frequently Asked Questions",
  "support.faqDesc": "Find answers to common questions about music distribution, payments and more.",
};

const tr = {
  "support.guideUploadTitle": "Nasıl Müzik Yüklenir",
  "support.guideUpload1": "Adım 1: Yeni Yayın Oluştur",
  "support.guideUpload1Content": "\"Yayınlar\" bölümüne gidin ve \"Yeni Yayın\" butonuna tıklayın. Tekli (1 parça) veya Albüm/EP (birden fazla parça) seçin.",
  "support.guideUpload2": "Adım 2: Sesi Yükleyin",
  "support.guideUpload2Content": "Ses dosyanızı WAV formatında (önerilen) veya yüksek kaliteli MP3 (minimum 320 kbps) formatında yükleyin.",
  "support.guideUpload3": "Adım 3: Yayın Bilgilerini Ekleyin",
  "support.guideUpload3Content": "Yayın başlığını, ana sanatçı adını, türü ve yayın tarihini doldurun. Varsa düet sanatçılarını ekleyin.",
  "support.guideUpload4": "Adım 4: Kapak Resmini Yükleyin",
  "support.guideUpload4Content": "JPG veya PNG formatında kare bir resim (minimum 3000×3000 piksel) yükleyin.",
  "support.guideUpload5": "Adım 5: Parça Detaylarını Ekleyin",
  "support.guideUpload5Content": "Her parça için başlık, ISRC kodu (isteğe bağlı), söz yazarları ve yapımcıları belirtin.",
  "support.guideUpload6": "Adım 6: İncele ve Gönder",
  "support.guideUpload6Content": "Tüm bilgileri dikkatlice inceleyin. Gönderildikten sonra yayınınız 24-72 saat içinde incelenir.",
  "support.tip1": "En iyi ses kalitesi için WAV formatını kullanın",
  "support.tip2": "Kapak resmi kare olmalıdır (1:1 oran)",
  "support.tip3": "Yayınları en az 7 gün öncesinden planlayın",
  "support.tip4": "Sanatçı isimlerinin doğru yazıldığından emin olun",
  "support.guidePaymentsTitle": "Ödemeler Nasıl Çalışır",
  "support.guidePayments1": "Telif Kazancı",
  "support.guidePayments1Content": "Müziğiniz Spotify, Apple Music, YouTube Music ve daha birçok platformda her dinlendiğinde veya indirildiğinde telif kazanırsınız.",
  "support.guidePayments2": "Komisyon Yapısı",
  "support.guidePayments2Content": "Ücretsiz plan: %20 komisyon. Artist Unlimited: %0 komisyon.",
  "support.guidePayments3": "Para Çekme Şartları",
  "support.guidePayments3Content": "Ödeme profilinizi tamamlayın, doğrulanmış bir ödeme yöntemi ekleyin ve minimum $50 bakiyeye ulaşın.",
  "support.guidePayments4": "Haftalık Çekim Limiti",
  "support.guidePayments4Content": "Haftada en fazla 2 çekim talebi. Her biri 3-5 iş günü içinde işlenir.",
  "support.tip5": "Çekim talebinden önce ödeme profilinizi ve vergi bilgilerinizi tamamlayın",
  "support.tip6": "Banka transferlerinin ücretleri PayPal'dan daha düşüktür",
  "support.tip7": "Kazançlar dinlenmelerden 30-60 gün sonra görünür",
  "support.guideDistributionTitle": "Dağıtım Rehberi",
  "support.guideDistribution1": "Desteklenen Platformlar",
  "support.guideDistribution1Content": "Müziğiniz Spotify, Apple Music, YouTube Music, Amazon Music, Deezer, Tidal ve TikTok dahil 150'den fazla platforma dağıtılır.",
  "support.guideDistribution2": "Teslimat Süreleri",
  "support.guideDistribution2Content": "Standart teslimat: 2-5 iş günü. Öncelikli teslimat (ücretli planlar): 24-72 saat.",
  "support.guideDistribution3": "İçerik Gereksinimleri",
  "support.guideDistribution3Content": "Sadece orijinal içerik. Cover şarkılar uygun lisans gerektirir. Remix'ler orijinal sanatçının iznini gerektirir.",
  "support.guideDistribution4": "Ses Kalitesi",
  "support.guideDistribution4Content": "WAV dosyaları: 16-bit veya 24-bit, 44.1 kHz veya daha yüksek. MP3 dosyaları: minimum 320 kbps.",
  "support.tip8": "Ön kayıt (pre-save) için yayınları 2-4 hafta öncesinden planlayın",
  "support.tip9": "Cuma, standart müzik yayın günüdür",
  "support.tip10": "Yayın öncesinde ve sonrasında tanıtım yapın",
  "support.faq1Q": "Yayınlarımın yayına girmesi ne kadar sürer?",
  "support.faq1A": "Onaylandıktan sonra yayınınızın tüm platformlarda görünmesi genellikle 2-5 iş günü sürer.",
  "support.faq2Q": "Yayındayken düzenleme yapabilir miyim?",
  "support.faq2A": "Destek talebi oluşturarak değişiklik isteyebilirsiniz. Metadata değişiklikleri genellikle güncellenebilir.",
  "support.faq3Q": "Çekilebilir bakiyem neden toplam bakiyemden farklı?",
  "support.faq3A": "Yeni kazançların çekilebilir hale gelmeden önce 30 günlük bekleme süresi vardır.",
  "support.faq4Q": "Ödeme almak için kimlik doğrulaması (KYC) gerekiyor mu?",
  "support.faq4A": "Hayır. Yalnızca tamamlanmış bir ödeme profili (vergi bilgileriyle) ve doğrulanmış bir ödeme yöntemi yeterli.",
  "support.faq5Q": "Cover şarkı yayınlayabilir miyim?",
  "support.faq5A": "Evet, ancak mekanik lisansa ihtiyacınız var. Gönderim sırasında lisans kanıtını yükleyin.",
  "support.faq6Q": "Gelir paylaşımları nasıl çalışır?",
  "support.faq6A": "Kazançları ortak çalışanlarla paylaşabilirsiniz. Katkıda bulunanları e-postayla davet edin, yüzdeleri belirleyin; kazançlar otomatik olarak dağıtılır.",
  "support.faq7Q": "Yayınım reddedilirse ne olur?",
  "support.faq7A": "Nedenini açıklayan bir bildirim alırsınız. Sorunları düzeltip yeniden gönderin.",
  "support.filterStatus": "Durum Filtresi",
  "support.allStatuses": "Tüm Durumlar",
  "support.noResults": "Sonuç bulunamadı",
  "support.noResultsDesc": "Arama kriterlerinize uygun destek talebi bulamadık.",
  "support.emptyDesc": "Desteğe ihtiyacınız olduğunda buradan yeni bir talep oluşturabilirsiniz.",
  "support.createFirst": "İlk Talebini Oluştur",
  "support.guideSteps": "{n} adım içerir",
  "support.readGuide": "Rehberi Oku",
  "support.guideFollow": "Adım adım kılavuzu takip edin",
  "support.proTips": "Pro İpuçları",
  "support.faqTitle": "Sıkça Sorulan Sorular",
  "support.faqDesc": "Müzik dağıtımı, ödemeler ve daha fazlası hakkında sık sorulan soruların cevaplarını bulun.",
};

const es = {
  "support.guideUploadTitle": "Cómo subir música",
  "support.guideUpload1": "Paso 1: Crea un nuevo lanzamiento",
  "support.guideUpload1Content": "Ve a \"Lanzamientos\" y haz clic en \"Nuevo lanzamiento\". Elige Single (1 pista) o Álbum/EP (varias pistas).",
  "support.guideUpload2": "Paso 2: Sube el audio",
  "support.guideUpload2Content": "Sube tu audio en WAV (recomendado) o MP3 de alta calidad (mínimo 320 kbps).",
  "support.guideUpload3": "Paso 3: Añade los datos del lanzamiento",
  "support.guideUpload3Content": "Completa el título, el artista principal, el género y la fecha de lanzamiento. Añade artistas invitados si los hay.",
  "support.guideUpload4": "Paso 4: Sube la portada",
  "support.guideUpload4Content": "Sube una imagen cuadrada JPG o PNG (mínimo 3000×3000 píxeles).",
  "support.guideUpload5": "Paso 5: Añade los detalles de las pistas",
  "support.guideUpload5Content": "Para cada pista indica el título, el código ISRC (opcional), los compositores y los productores.",
  "support.guideUpload6": "Paso 6: Revisa y envía",
  "support.guideUpload6Content": "Revisa todos los datos con atención. Tras el envío, tu lanzamiento se revisa en 24–72 horas.",
  "support.tip1": "Usa WAV para la mejor calidad de audio",
  "support.tip2": "La portada debe ser cuadrada (relación 1:1)",
  "support.tip3": "Programa los lanzamientos con al menos 7 días de antelación",
  "support.tip4": "Asegúrate de que los nombres de los artistas estén bien escritos",
  "support.guidePaymentsTitle": "Cómo funcionan los pagos",
  "support.guidePayments1": "Regalías",
  "support.guidePayments1Content": "Ganas regalías cada vez que tu música se reproduce o descarga en Spotify, Apple Music, YouTube Music y muchas plataformas más.",
  "support.guidePayments2": "Estructura de comisiones",
  "support.guidePayments2Content": "Plan gratuito: 20% de comisión. Artist Unlimited: 0% de comisión.",
  "support.guidePayments3": "Requisitos para retirar",
  "support.guidePayments3Content": "Completa tu perfil de pagos, añade un método de pago verificado y alcanza un saldo mínimo de 50 $.",
  "support.guidePayments4": "Límite semanal de retiros",
  "support.guidePayments4Content": "Hasta 2 solicitudes de retiro por semana. Cada una se procesa en 3–5 días hábiles.",
  "support.tip5": "Completa tu perfil de pago y tus datos fiscales antes de solicitar un retiro",
  "support.tip6": "Las transferencias bancarias tienen comisiones más bajas que PayPal",
  "support.tip7": "Las ganancias aparecen 30–60 días después de las reproducciones",
  "support.guideDistributionTitle": "Guía de distribución",
  "support.guideDistribution1": "Plataformas compatibles",
  "support.guideDistribution1Content": "Tu música se distribuye a más de 150 plataformas, incluidas Spotify, Apple Music, YouTube Music, Amazon Music, Deezer, Tidal y TikTok.",
  "support.guideDistribution2": "Plazos de entrega",
  "support.guideDistribution2Content": "Entrega estándar: 2–5 días hábiles. Entrega prioritaria (planes de pago): 24–72 horas.",
  "support.guideDistribution3": "Requisitos de contenido",
  "support.guideDistribution3Content": "Solo contenido original. Las versiones (covers) requieren licencia. Los remixes requieren el permiso del artista original.",
  "support.guideDistribution4": "Calidad de audio",
  "support.guideDistribution4Content": "Archivos WAV: 16 o 24 bits, 44,1 kHz o más. Archivos MP3: mínimo 320 kbps.",
  "support.tip8": "Planifica los lanzamientos 2–4 semanas antes para campañas de pre-save",
  "support.tip9": "El viernes es el día estándar de lanzamientos",
  "support.tip10": "Promociona antes y después del lanzamiento",
  "support.faq1Q": "¿Cuánto tarda mi lanzamiento en publicarse?",
  "support.faq1A": "Una vez aprobado, tu lanzamiento suele aparecer en todas las plataformas en 2–5 días hábiles.",
  "support.faq2Q": "¿Puedo editar mi lanzamiento una vez publicado?",
  "support.faq2A": "Puedes solicitar cambios abriendo un ticket de soporte. Los cambios de metadatos normalmente se pueden actualizar.",
  "support.faq3Q": "¿Por qué mi saldo retirable es distinto de mi saldo total?",
  "support.faq3A": "Las nuevas ganancias tienen un período de retención de 30 días antes de poder retirarse.",
  "support.faq4Q": "¿Necesito verificar mi identidad (KYC) para cobrar?",
  "support.faq4A": "No. Solo necesitas un perfil de pago completo (con datos fiscales) y un método de pago verificado.",
  "support.faq5Q": "¿Puedo publicar versiones (covers)?",
  "support.faq5A": "Sí, pero necesitas una licencia mecánica. Sube la prueba de la licencia al enviar.",
  "support.faq6Q": "¿Cómo funcionan los repartos de ingresos?",
  "support.faq6A": "Puedes compartir ganancias con colaboradores. Invítalos por e-mail, fija los porcentajes y las ganancias se reparten automáticamente.",
  "support.faq7Q": "¿Qué pasa si rechazan mi lanzamiento?",
  "support.faq7A": "Recibirás una notificación con el motivo. Corrige los problemas y vuelve a enviarlo.",
  "support.filterStatus": "Filtro de estado",
  "support.allStatuses": "Todos los estados",
  "support.noResults": "No se encontraron resultados",
  "support.noResultsDesc": "No encontramos tickets de soporte que coincidan con tu búsqueda.",
  "support.emptyDesc": "Cuando necesites ayuda, puedes crear un nuevo ticket aquí.",
  "support.createFirst": "Crea tu primer ticket",
  "support.guideSteps": "{n} pasos",
  "support.readGuide": "Leer la guía",
  "support.guideFollow": "Sigue la guía paso a paso",
  "support.proTips": "Consejos pro",
  "support.faqTitle": "Preguntas frecuentes",
  "support.faqDesc": "Encuentra respuestas a preguntas comunes sobre distribución musical, pagos y más.",
};

export default { en, tr, es };
